import { ICoreServiceModel } from './model/ICoreServiceModel';
import { CoreRestCRUDService } from '../coreCommon/common/rest/CoreRestCRUDService';
import { ILearningConfig } from '../../application/config/learning/ILearningConfig';
import { LearningEnvConfigManager } from '../../application/config/learning/LearningEnvConfigManager';

export abstract class LearningCoreRestCRUDService<ModelType  extends ICoreServiceModel> extends CoreRestCRUDService<ModelType >{
    abstract getEndpoint(): string;

    protected learningConfig: ILearningConfig = LearningEnvConfigManager.getConfig();
}
